import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Box,
  useTheme,
} from "@mui/material";


const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  company: Yup.string().required("Company is required"),
  title: Yup.string(),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string(),
  products: Yup.array().min(1, "Select at least one product"),
  message: Yup.string(),
});

const RequestDemo = () => {
   const theme = useTheme();
  return (
    <Box
      sx={{
        minHeight: "100vh",
        
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: 5,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: "900px", px: 3 }}>
        {/* Heading */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 4,
           color: theme.palette.text.primary
          }}
        >
          REQUEST A DEMO
        </Typography>

        <Formik
          initialValues={{
            name: "",
            company: "",
            title: "",
            email: "",
            phone: "",
            products: [],
            message: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            try {
              const payload = {
                recipients: process.env.REACT_APP_RECIPIENTS,
                subject: `Demo Request from ${values.name} (${values.company})`,
                message: `
                          <p><strong>Name:</strong> ${values.name}</p>
                          <p><strong>Company:</strong> ${values.company}</p>
                          <p><strong>Title:</strong> ${values.title}</p>
                          <p><strong>Email:</strong> ${values.email}</p>
                          <p><strong>Phone:</strong> ${values.phone}</p>
                          <p><strong>Products:</strong> ${values.products.join(", ")}</p>
                          <p><strong>Message:</strong><br/>${values.message}</p>
                        `.trim(),
              };

              const response = await fetch(process.env.REACT_APP_NOTIFY_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              });
              const contentType = response.headers.get("content-type");
              if (contentType && contentType.includes("application/json")) {
                await response.json();
              } else {
                await response.text();
              }
              resetForm();
            } catch (error) {
              console.error("Error submitting form:");
            }
          }}

        >
          {({ errors, touched, values, handleChange }) => (
            <Form>
              {/* Name */}
              <Field
                as={TextField}
                name="name"
                label="Name *"
                fullWidth
                margin="normal"
                variant="outlined"
                InputProps={{
                  style: { borderRadius: 8 },
                }}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />

              {/* Company */}
              <Field
                as={TextField}
                name="company"
                label="Company *"
                fullWidth
                margin="normal"
                variant="outlined"
                InputProps={{
                  style: { borderRadius: 8 },
                }}
                error={touched.company && Boolean(errors.company)}
                helperText={touched.company && errors.company}
              />

              {/* Title */}
              <Field
                as={TextField}
                name="title"
                label="Title"
                fullWidth
                margin="normal"
                variant="outlined"
                InputProps={{
                  style: { borderRadius: 8 },
                }}
              />

              {/* Email */}
              <Field
                as={TextField}
                name="email"
                label="Email *"
                fullWidth
                margin="normal"
                variant="outlined"
                InputProps={{
                  style: { borderRadius: 8 },
                }}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
              />

              {/* Phone */}
              <Field
                as={TextField}
                name="phone"
                label="Phone"
                fullWidth
                margin="normal"
                variant="outlined"
                InputProps={{
                  style: { borderRadius: 8 },
                }}
              />

              {/* Product of Interest */}
              <Typography sx={{ mt: 3, fontWeight: 500 }}>
                Product of Interest *
              </Typography>
              <FormGroup row sx={{ mb: 2 }}>
                {["CTMS", "Insights RM", "Informer", "BioPhy"].map((product) => (
                  <FormControlLabel
                    key={product}
                    control={
                      <Checkbox
                        name="products"
                        value={product}
                        checked={values.products.includes(product)}
                        onChange={handleChange}
                      />
                    }
                    label={product}
                  />
                ))}
              </FormGroup>
              {touched.products && errors.products && (
                <Typography color="error" variant="caption">
                  {errors.products}
                </Typography>
              )}

              {/* Message */}
              <Field
                as={TextField}
                name="message"
                label="Comment or Message"
                fullWidth
                margin="normal"
                multiline
                rows={4}
                variant="outlined"
                InputProps={{
                  style: { borderRadius: 8 },
                }}
              />

              {/* Submit */}
              <Box textAlign="left" sx={{ mt: 3 }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    mb: 5,
                    backgroundColor: "#00AEEF",
                    color: "white",
                    px: 4,
                    py: 1.2,
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 500,
                    "&:hover": { backgroundColor: "#008ECC" },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default RequestDemo;
